<template>
    <v-col class="pt-0 stepContainer" cols="12" sm="12">
        <!-- >>> Title -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <h2 v-if="leg === 'firstLeg'" class="mb-2">
                    First Leg
                </h2>
                <h2 v-if="leg === 'secondLeg'" class="mb-2">
                    Second Leg
                </h2>
            </v-col>
        </v-row>
        <!-- <<< Title -->


        <!-- >>> Row 1 -->
        <!--  || editorMode === 'update' -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <p class="font-weight-bold mb-0">
                    General Information
                </p>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-combobox
                            v-model="data[leg].input_AirportSlot"
                            tabindex="1"
                            :rules ="[
                                rules.req(data[leg].input_AirportSlot),
                            ]"
                            :items="get_Airports"
                            class="uppercase"
                            item-value="iataCode"
                            item-text="iataCode"
                            prepend-icon="mdi-airplane-takeoff"
                            style="font-size:1rem;"
                            @input="onChange_AirportSlot">
                            <template v-slot:label>
                                <p>
                                Airport <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-combobox>
                    </v-col>
                     <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="data[leg].input_FlightNo"
                            tabindex="2"
                            :rules ="[
                                rules.req(data[leg].input_FlightNo),
                            ]"
                            name="input_FlightNo"
                            class="uppercase"
                            maxlength="8"
                            counter
                            prepend-icon="mdi-numeric"
                            clearable
                            persistent-hint
                            style="font-size:1rem;">
                            <template v-slot:label>
                                <p>
                                    Flight# <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="py-0" cols="12" sm="12">
                        <v-row />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select
                            v-model="data[leg].input_AircraftConfig"
                            tabindex="3"
                            :rules ="[
                                rules.req(data[leg].input_AircraftConfig),
                            ]"
                            :items="get_AircraftConfigs"
                            item-value="idAircraft"
                            item-text="code"
                            prepend-icon="mdi-airplane"
                            clearable>
                            <template v-slot:label>
                                <p>
                                Aircraft Config <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-select>
                    </v-col>
                        <v-col cols="12" sm="6">
                        <v-select
                            v-model="data[leg].input_MainServiceType"
                            tabindex="4"
                            :rules ="[
                                rules.req(data[leg].input_MainServiceType),
                            ]"
                            :items="items_MainServiceTypes"
                            prepend-icon="mdi-dots-square">
                            <template v-slot:label>
                                <p>
                                Main Service Type <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <<< Row 1 -->


        <!-- >>> Row 2 -->
        <p class="font-weight-bold mb-0">
            Slot Information
        </p>
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-select
                            v-model="data[leg].input_Direction"
                            tabindex="5"
                            :rules ="[
                                rules.req(data[leg].input_Direction),
                            ]"
                            :items="items_Direction"
                            prepend-icon="mdi-sign-direction">
                            <template v-slot:label>
                                <p>
                                Direction <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <<< Row 2 -->

         <!-- >>> Row 3 -->
        <v-row>
            <v-col class="py-0" cols="12" sm="12">
                <v-row :style="{flexDirection: data[leg].input_Direction === 'DEPARTURE' ? 'row-reverse' : ''}">
                    <v-col cols="12" sm="6">
                        <v-combobox
                            v-model="data[leg].input_Airport"
                            :tabindex="data[leg].input_Direction === 'DEPARTURE' ? 7 : 6"
                            :rules ="[
                                rules.req(data[leg].input_Airport),
                            ]"
                            :items="get_Airports"
                            class="uppercase"
                            item-value="iataCode"
                            item-text="iataCode"
                            :prepend-icon="data[leg].input_Direction === 'DEPARTURE' ? 'mdi-airplane-landing' : 'mdi-airplane-takeoff'"
                            style="font-size:1rem;"
                            @input="onChange_Airport">
                            <template v-slot:label>
                                <p>
                                Airport {{ data[leg].input_Direction === 'DEPARTURE' ? ' (Prv)' : '(Org)' }} <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-combobox>
                    </v-col>

                    <v-col cols="12" :sm="6">
                        <v-text-field
                            v-model="data[leg].input_Slot_Time"
                            :tabindex="data[leg].input_Direction === 'DEPARTURE' ? 6 : 7"
                            :rules ="[
                                rules.req(data[leg].input_Slot_Time),
                            ]"
                            style="font-size:1rem;"
                            prepend-icon="mdi-clock-time-four-outline"
                            type="time"
                            persistent-hint>
                            <template v-slot:label>
                                <p>
                                {{ data[leg].input_Direction === 'DEPARTURE' ? ' STD' : 'STA' }} <span style="color: red; font-size: 1.4rem;">*</span>
                                </p>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <<< Row 3 -->
</v-col>
</template>

<script>
import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import dayjs from 'dayjs';


    export default {
        name: 'SdrStep1Flightconfig',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'update', 'create'
            editorFlightLegMode: String, // 'single', 'rotation'
            data: Object, // entire 'crud' Object
            leg: String, // "firstLeg", "secondLeg"
            rules: Object, // entire 'rules' Object
            showDeleteCheckbox: Boolean

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ----- GENERAL INFORMATION
                input_FlightNo: '',
                input_AircraftConfig: null,
                input_MainServiceType: 'C',

                // >>> ----- SLOT INFORMATION
                input_Direction: 'DEPARTURE',
                input_AirportSlot: null, // requested airport
                input_Airport: null, // origin or destination
                input_Slot_Time: null, // origin time or destination time

                // >>> ----- PERIOD INFORMATION
                input_Season: '',
                input_dateRange: '',
                dateRangeMenu: false,
                formattedDateRange: '',
                input_dow: [],

                // >>> ----- ITEMS
                items_MainServiceTypes: [
                    {
                        text: 'C - Charter Flight',
                        value: 'C'
                    },
                    {
                        text: 'J - Scheduled Flight',
                        value: 'J'
                    }
                ],
                items_Direction: [
                    'ARRIVAL',
                    'DEPARTURE'
                ],
				items_Days: [
                    { text: '1', value: 1, backendValue: 'MONDAY' },
                    { text: '2', value: 2, backendValue: 'TUESDAY' },
                    { text: '3', value: 3, backendValue: 'WEDNESDAY' },
                    { text: '4', value: 4, backendValue: 'THURSDAY' },
                    { text: '5', value: 5, backendValue: 'FRIDAY' },
                    { text: '6', value: 6, backendValue: 'SATURDAY' },
                    { text: '7', value: 0, backendValue: 'SUNDAY' }
                ]
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([

                'get_AircraftConfigs',
                'get_Airports'

            ])

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* watch */
        watch: {}, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/Step1FlightConfig.vue >>> created');
            eventBus.$on('flightswasupdated', this.onEmit_FlightWasUpdated);

		}, // eo function created()
		/* <<< ****************************************************************/



        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/Step1FlightConfig.vue >>> destroyed');
            eventBus.$off('flightswasupdated', this.onEmit_FlightWasUpdated);

		}, // eo function destroyed()
        /* <<< *************************************************************** /



        /* >>> ***************************************************************** / /* Methods */
        methods: {


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/

            /*******************************************************************
            * onChange_input_AircraftConfig
            *
            * Desc:
            * Note:
            *
            */
            onChange_input_AircraftConfig: function() {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step1FlightsConfig.vue >>> onChange_input_AircraftConfig');
                if (this.leg === 'firstLeg') {
                    this.data.secondLeg.input_AircraftConfig = this.data.firstLeg.input_AircraftConfig;
                }

                if (this.leg === 'secondLeg') {
                    this.data.firstLeg.input_AircraftConfig = this.data.secondLeg.input_AircraftConfig;
                }

            }, // eo function onChange_input_AircraftConfig()

            /*******************************************************************
            * onChange_Airport()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_Airport: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/slotmanagement/components/core/BottomSheet.vue >>> onChange_Departure');
                if (Vue.prototype.$isEmpty(me.data[me.leg].input_Airport)) {
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.data[me.leg].input_Airport !== 'object') {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.data[me.leg].input_Airport.toUpperCase());
                } else {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.data[me.leg].input_Airport.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.data[me.leg].input_Airport = airport;
                } else {
                    me.data[me.leg].input_Airport = '';
                }

            }, // eo function onChange_Airport()

            /*******************************************************************
            * onChange_AirportSlot()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_AirportSlot: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/slotmanagement/components/core/BottomSheet.vue >>> onChange_AirportSlot');
                if (Vue.prototype.$isEmpty(me.data[me.leg].input_AirportSlot)) {
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.data[me.leg].input_AirportSlot !== 'object') {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.data[me.leg].input_AirportSlot.toUpperCase());
                } else {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.data[me.leg].input_AirportSlot.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.data[me.leg].input_AirportSlot = airport;
                } else {
                    me.data[me.leg].input_AirportSlot = '';
                }

            }, // eo function onChange_AirportSlot()


            /*******************************************************************
            * onChange_deleteForAll
            *
            * Desc:
            * Note:
            *
            */
            onChange_deleteForAll: function(leg, value, type, inputName) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/Step1FlightsConfig.vue >>> onChange_deleteForAll');
                me.data[me.leg][inputName] = '';
                eventBus.$emit('markToDeleteBus', { leg: leg, type: type, value: value });

            } // eo function onChange_deleteForAll()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
